import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'
import { emptySAR } from '~bank-bsa-reporting/constants'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../SubjectInformationItemContext'
import { IdCountry, IdForm, IdFormOther, IdNumber, IdState } from './fields'

export const FormOfIdentification = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.idsInfo`
  })

  return (
    <>
      <FormRow>
        <Col2x>
          <h5>18. Form of identification for subject</h5>
        </Col2x>
      </FormRow>

      {fields.map((field, index2) => (
        <FormOfIdentificationItem
          index1={index}
          index2={index2}
          key={field.id}
          rowsNumber={fields.length}
          onDelete={remove}
        />
      ))}

      {!isAllInfoUnavailable && (
        <IconButton icon={IconName.ADD_GREEN} onClick={() => append(emptySAR.subjectsInfo[0].idsInfo[0])} />
      )}
    </>
  )
}

const FormOfIdentificationItem = ({
  index1,
  index2,
  rowsNumber,
  onDelete
}: {
  index1: number
  index2: number
  rowsNumber: number
  onDelete: (index: number) => void
}) => {
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => onDelete(index2),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <FormRow>
        <Col>
          <IdForm index1={index1} index2={index2} />
        </Col>
        <Col>
          <IdFormOther index1={index1} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <IdNumber index1={index1} index2={index2} />
        </Col>
        <Col>
          <IdCountry index1={index1} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <IdState index1={index1} index2={index2} />
        </Col>
        {rowsNumber > 1 && !isAllInfoUnavailable && (
          <IconButton face="negative" icon={IconName.DELETE} onClick={startDeleting} />
        )}
      </FormRow>
    </>
  )
}
